module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/border-left.7f3687d7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/border-left.png
// module id = 2746
// module chunks = 11